import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { setSearchQuery, setSearchInput, unsetSearchQuery, unsetSearchInput } from '../actions';
import { getSearchQuery, getSearchInput } from '../selectors';
export const useSearch = ()=>_object_spread({}, useMMSelector((state)=>({
            searchQuery: getSearchQuery(state),
            searchInput: getSearchInput(state)
        })), useMMDispatchActions({
        setSearchQuery,
        unsetSearchQuery,
        setSearchInput,
        unsetSearchInput
    }));
export default connectMediaStore((state)=>({
        searchQuery: getSearchQuery(state),
        searchInput: getSearchInput(state)
    }), {
    setSearchQuery,
    unsetSearchQuery,
    setSearchInput,
    unsetSearchInput
});

//# sourceMappingURL=withSearch.js.map